module.exports = __webpack_public_path__ + "static/media/texture (11).b29755e8.jpg";